export default "__VITE_ASSET__350fdc61__"